import React from 'react';
import { useSelector } from 'react-redux';
import { OneFormState } from 'src/types';

export function ThankYouComponent() {
  const { thankYouComponent } = useSelector((state: OneFormState) => state.formInfo);
  return { ...thankYouComponent };
}
